import { useSelector } from 'react-redux'
import { format } from 'date-fns'
import { getDateTimeFormat } from '../reducers/userObject/selectors/settings'
import { timeFormat } from '../utils/DateFormat'

export const useFormatTime = (): ((date: Date) => string) => {
  const formatDate = useSelector(getDateTimeFormat)
  return (date: Date) =>
    format(
      date,
      timeFormat(
        formatDate && formatDate.formatHours ? formatDate.formatHours : 'HH:mm',
      ),
    )
}
